module.exports = __webpack_public_path__ + "static/media/twitter.a6f280e3.svg";